module.exports = __webpack_public_path__ + "img/cx.95acc8ce.svg";